module.exports = __webpack_public_path__ + "img/7-mob.91ac0809.svg";